"use client";

import React from "react";
import AppLayout from "@/components/layout/AppLayout";
import { useRole } from "@/utils/RoleContext";

export default function RoleBasedLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { role, isRoleLoaded } = useRole();

  if (!isRoleLoaded) {
    return <AppLayout>{children}</AppLayout>;
  }

  if (role === "govauth") {
    return <>{children}</>;
  }

  return <AppLayout>{children}</AppLayout>;
}
